import React, { useEffect } from "react";
import { Modal, Form, Input, Alert } from "antd";

import EntityInfo from "../../types/EntityInfo";
import { useTexts } from "../../hooks/useTexts";

type Props = {
    open: boolean,
    city: EntityInfo | null,
    submitting: boolean,
    errors: string[],
    onClose: () => void,
    onSave: (name: string) => void
}

const CityModal = ({ open, city, submitting, errors, onClose, onSave }: Props): JSX.Element => {
    const { t } = useTexts();
    const [form] = Form.useForm();

    useEffect(() => {
        if (open) {
            form.setFieldsValue({ name: city?.name || '' });
        }
    }, [open, city, form]);

    return (
        <Modal
            title={city ? t('city', 'editCity') : t('city', 'addCity')}
            open={open}
            onCancel={onClose}
            onOk={() => {
                form.validateFields().then(values => {
                    onSave(values.name?.trim());
                });
            }}
            okText={t('common', 'save')}
            cancelText={t('common', 'close')}
            confirmLoading={submitting}
            destroyOnClose
        >
            {errors?.length > 0 && (
                <div style={{ marginTop: '16px' }}>
                    {errors.map((err, idx) => (
                        <Alert key={idx} message={err} type="error" showIcon style={{ marginBottom: '8px' }} />
                    ))}
                </div>
            )}

            <Form
                form={form}
                layout="vertical"
                style={{ marginTop: '24px' }}
            >
                <Form.Item
                    label={t('city', 'cityName')}
                    name="name"
                    rules={[{ required: true, message: t('city', 'nameRequired') }]}
                >
                    <Input placeholder={t('city', 'cityName')} />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default CityModal;
